import { Link } from "react-router-dom";
import { Clock, MapPin } from "lucide-react";

// IMAGES
import kandySigiriya from "../accests/kan/kan (3).jpeg";
import udawalaweYala from "../accests/udawalawa/udawalawa (2).jpeg";
import yalaGalle from "../accests/yala/leopardImg.jfif";
import kandyEllaYala from "../accests/kithul/kithul.jpeg";
import sriLankaDiscovery from "../accests/sigiri/sigiri (11).jpeg";
import epicLanka from "../accests/mirissa/tha.jpeg";
import summerTour from "../accests/bentota/ben (2).jpeg";

export default function RoundTours() {
    const tours = [
        {
            title: "Kandy, Sigiriya & Dambulla Tour",
            duration: "2 Days",
            image: kandySigiriya,
            location: "Cultural Triangle",
            link: "/tours/round-tours/kandy-sigiriya-dambulla",
        },
        {
            title: "Udawalawe & Yala Safari Tour",
            duration: "2 Days",
            image: udawalaweYala,
            location: "Udawalawe & Yala",
            link: "/tours/round-tours/udawalawe-yala",
        },
        {
            title: "Yala & Galle Two Day Tour",
            duration: "2 Days",
            image: yalaGalle,
            location: "Yala & Galle",
            link: "/tours/round-tours/yala-galle",
        },
        {
            title: "Kandy, Ella, Yala & Galle Four Day Tour",
            duration: "4 Days",
            image: kandyEllaYala,
            location: "Central & South",
            link: "/tours/round-tours/kandy-ella-yala",
        },
        {
            title: "Sri Lanka Discovery Tour",
            duration: "7 Days",
            image: sriLankaDiscovery,
            location: "Islandwide",
            link: "/tours/round-tours/sri-lanka-discovery-tour",
        },
        {
            title: "Epic Lanka Tour",
            duration: "10 Days",
            image: epicLanka,
            location: "Islandwide",
            link: "/tours/round-tours/epic-lanka-tour",
        },
        {
            title: "Summer Tour",
            duration: "15 Days",
            image: summerTour,
            location: "Islandwide",
            link: "/tours/round-tours/summer-tour",
        },
    ];

    return (
        <div className="pt-28 pb-20 bg-gray-50">

            {/* HEADER */}
            <div className="text-center mb-16 px-6">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                    Explore Our <span className="text-red-600">Round Tours</span>
                </h1>
                <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                    Multi-day adventures covering culture, wildlife, beaches, and scenic experiences across Sri Lanka.
                </p>
            </div>

            {/* TOURS GRID */}
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                {tours.map((tour, index) => (
                    <Link
                        to={tour.link}
                        key={index}
                        className="group relative rounded-3xl overflow-hidden shadow-xl bg-black"
                    >
                        {/* IMAGE */}
                        <img
                            src={tour.image}
                            alt={tour.title}
                            className="w-full h-[360px] object-cover group-hover:scale-110 transition-transform duration-700"
                        />

                        {/* OVERLAY */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                        {/* DURATION BADGE */}
                        <div className="absolute top-4 left-4 flex items-center gap-2 bg-white text-black px-4 py-1 rounded-full text-sm font-semibold shadow-lg">
                            <Clock size={16} />
                            {tour.duration}
                        </div>

                        {/* CONTENT */}
                        <div className="absolute bottom-6 left-6 right-6 text-white">
                            <h3 className="text-2xl font-bold mb-2">{tour.title}</h3>
                            <div className="flex items-center gap-2 text-sm text-gray-200">
                                <MapPin size={16} className="text-red-500" />
                                {tour.location}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
